"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
//
// assets
//
const noOrders_webp_1 = __importDefault(require("../../../assets/images/dashboard/noOrders.webp"));
const queryDefinitions_1 = require("../../../queryDefinitions");
const ordersCopy_1 = require("../../../copy/ordersCopy");
//
// components
//
const OrderModal_1 = __importDefault(require("../Modals/OrderModal"));
//
// hooks
//
const useInfiniteScroll_1 = require("../../../hooks/useInfiniteScroll");
const usePaginatedSearch_1 = __importDefault(require("../../usePaginatedSearch"));
const useAccountChange_1 = __importDefault(require("../../useAccountChange"));
const tokenHeader_1 = require("../../../tokenHeader");
//
// styles
//
const StyledHeader_1 = require("../StyledHeader");
const StyledMainContainer_1 = require("../StyledMainContainer");
const ProblemOrdersRules_1 = require("./ProblemOrdersRules");
const DateFormat_1 = require("../../general/utility/DateFormat");
const pageCount = 12;
const StyledHeaderContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
const StyledRightAlignedTableCell = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
`;
const LoadMoreButtonContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding: 1rem;
  width: 100%;
`;
const TableFiltersContainer = styled_components_1.default.div `
  padding: 1rem;
  display: flex;

  > div {
    flex: 1;
  }
`;
const Orders = () => {
    var _a, _b, _c, _d;
    const [detailedOrder, setDetailedOrder] = (0, react_1.useState)();
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [showProblemOrderRules, setShowProblemOrderRules] = (0, react_1.useState)(false);
    const [getFirstPageOrders, 
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loading' does not exist on type '((optio... Remove this comment to see the full error message
    { loading, data, fetchMore, renderWithLoadingAndErrorHandling }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_ORDERS);
    (0, useAccountChange_1.default)(() => {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getFirstPageOrders({ variables: { first: pageCount } });
    });
    const { searched, searchQuery, handleSearch, handleLoadNext } = (0, usePaginatedSearch_1.default)(fetchMore, 'orders', data);
    (0, useInfiniteScroll_1.useInfiniteScroll)({
        hasNext: ((_b = (_a = data === null || data === void 0 ? void 0 : data.orders) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.hasNextPage) || false,
        loadNext: handleLoadNext
    });
    function handleToggleModal() {
        setShowModal((current) => !current);
    }
    const resourceName = {
        singular: 'order',
        plural: 'orders'
    };
    const orders = ((_d = (_c = data === null || data === void 0 ? void 0 : data.orders) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map(({ node }) => node)) || [];
    const handleClearAll = (0, react_1.useCallback)(() => {
        handleSearch('');
    }, [handleSearch]);
    const rowMarkup = orders.map((order, index) => (react_1.default.createElement(polaris_1.IndexTable.Row, { id: order.number, key: `order:${order.number}:${index}`, position: index },
        react_1.default.createElement(polaris_1.IndexTable.Cell, null,
            react_1.default.createElement(polaris_1.TextStyle, { variation: 'strong' }, order.number)),
        react_1.default.createElement(polaris_1.IndexTable.Cell, null,
            order.customer.firstName,
            " ",
            order.customer.lastName),
        react_1.default.createElement(polaris_1.IndexTable.Cell, null, order.customer.email),
        react_1.default.createElement(polaris_1.IndexTable.Cell, null, (0, DateFormat_1.shortDateFormat)(order.insertedAt)),
        react_1.default.createElement(polaris_1.IndexTable.Cell, null,
            react_1.default.createElement(StyledRightAlignedTableCell, null,
                react_1.default.createElement(polaris_1.Button, { onClick: () => {
                        setDetailedOrder(order);
                        setShowModal(true);
                    } }, "Details"))))));
    function renderOrders() {
        var _a, _b;
        return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'orders' },
            react_1.default.createElement(ProblemOrdersRules_1.ProblemOrdersRules, { onHide: () => setShowProblemOrderRules(false), show: showProblemOrderRules }),
            detailedOrder && (react_1.default.createElement(OrderModal_1.default, { display: showModal, handleToggleModal: handleToggleModal, order: detailedOrder })),
            react_1.default.createElement(StyledHeaderContainer, null,
                react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, ordersCopy_1.ordersCopy.mainHeader),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(polaris_1.Button, { "aria-label": 'Problem Order Rules', icon: polaris_icons_1.AlertMinor, onClick: () => setShowProblemOrderRules(true) }, "Problem orders"))),
            react_1.default.createElement(polaris_1.Card, null,
                react_1.default.createElement(TableFiltersContainer, null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(polaris_1.Filters, { appliedFilters: [], filters: [], onClearAll: handleClearAll, onQueryChange: handleSearch, onQueryClear: () => handleSearch(''), queryPlaceholder: 'Search', queryValue: searchQuery }))),
                react_1.default.createElement(polaris_1.IndexTable, { headings: [
                        { title: 'Order' },
                        { title: 'Name' },
                        { title: 'Email' },
                        { title: 'Placed' },
                        { title: '' }
                    ], itemCount: orders.length, lastColumnSticky: true, loading: loading, resourceName: resourceName, selectable: false }, rowMarkup)),
            ((_b = (_a = data === null || data === void 0 ? void 0 : data.orders) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.hasNextPage) && (react_1.default.createElement(LoadMoreButtonContainer, null,
                react_1.default.createElement(polaris_1.Button, { onClick: handleLoadNext }, "Load More")))));
    }
    return renderWithLoadingAndErrorHandling({
        copy: {
            noRecordsHeader: ordersCopy_1.ordersCopy.noOrdersHeader,
            noRecordsParagraph: ordersCopy_1.ordersCopy.noOrdersParagraph,
            noRecordsImage: noOrders_webp_1.default
        },
        key: 'orders',
        searched,
        success: renderOrders
    });
};
exports.default = Orders;
